import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgRemoveAttachmentSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.03 0.00244141C9.98323 0.00244141 8.97804 0.412592 8.23027 1.14511L8.22173 1.15348L8.21338 1.16205L7.86913 1.51581L6.04111 3.33237L7.45577 4.74616L9.28484 2.92856L9.29078 2.92265L9.29663 2.91664L9.63754 2.56631C10.0105 2.20484 10.5099 2.00244 11.03 2.00244C11.55 2.00244 12.0493 2.20473 12.4222 2.56602C12.7817 2.93841 12.9827 3.43565 12.9827 3.95316C12.9827 4.47255 12.7803 4.97159 12.4184 5.34438L12.1251 5.63741L12.1232 5.63925L10.231 7.51969L11.6456 8.93348L13.5349 7.05602L13.5367 7.05418L13.8368 6.75444L13.8368 6.75449L13.8456 6.74552C14.5746 5.99876 14.9827 4.9966 14.9827 3.95316C14.9827 2.90966 14.5745 1.90764 13.8456 1.16091L13.8378 1.15292L13.8298 1.14511C13.082 0.412592 12.0768 0.00244141 11.03 0.00244141ZM12.0247 10.7261L12.5772 11.2783C12.7235 11.6401 12.6493 12.0701 12.3552 12.3626L10.2851 14.4213L10.2822 14.4242L10.2822 14.4242C9.25845 15.434 7.87805 16 6.43994 16C5.0018 16 3.62153 15.4339 2.59781 14.4242L2.59467 14.421C2.08991 13.9187 1.68915 13.3217 1.41572 12.664C1.1423 12.0063 1.00171 11.3011 1.00171 10.5891C1.00171 9.87711 1.1423 9.17197 1.41572 8.51427C1.68915 7.85656 2.08991 7.2595 2.59467 6.75719L2.59517 6.7567L5.33178 4.03725L6.74643 5.45104L4.00543 8.17486C3.68718 8.49156 3.43468 8.86782 3.2625 9.28201C3.09031 9.6962 3.00171 10.1404 3.00171 10.5891C3.00171 11.0378 3.09031 11.482 3.2625 11.8962C3.43441 12.3098 3.68637 12.6855 4.00389 13.0019C4.65309 13.6414 5.52808 14 6.43994 14C7.35195 14 8.22716 13.6413 8.87637 13.0016L8.87771 13.0003L10.9449 10.9445C11.2374 10.6535 11.6649 10.5809 12.0247 10.7261ZM10.9363 9.63838L9.52168 8.2246L6.82596 10.9036C6.73157 10.9774 6.61369 11.0159 6.49302 11.0116C6.36398 11.007 6.24164 10.9537 6.15049 10.8626C6.05943 10.7716 6.00628 10.6495 6.00168 10.521C5.99741 10.4018 6.03518 10.2852 6.10804 10.1913L8.64408 7.67639L8.64451 7.67597L8.80915 7.5125L7.3945 6.09871L7.2358 6.25627L7.23537 6.25669L4.66586 8.80476L4.63907 8.83133L4.61435 8.85984C4.19873 9.33934 3.98025 9.95841 4.00296 10.5926C4.02567 11.2267 4.28784 11.8287 4.73671 12.2773C5.18551 12.7258 5.78748 12.9877 6.42153 13.0103C7.05549 13.033 7.67475 12.8149 8.15453 12.3996L8.18052 12.3771L8.2049 12.3528L10.9363 9.63838ZM8.10414 5.39413L9.51879 6.80793L10.1946 6.13699C10.5865 5.74787 10.5887 5.11471 10.1996 4.72278C9.8105 4.33086 9.17734 4.32859 8.78542 4.71772L8.10414 5.39413Z"
      fill={props.color}
    />
    <path
      d="M1 1L15 14.9915"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgRemoveAttachmentSmall.displayName = 'SvgRemoveAttachmentSmall';
const RemoveAttachmentSmall = withForgeIconProps(SvgRemoveAttachmentSmall, {
  name: 'RemoveAttachment',
  usage: 'Use to remove an attachment.',
  related: 'attach, paperclip, clip, file, edit',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default RemoveAttachmentSmall;
